// frontend/packages/common/api/Widgets/Company/Company.js
import {useState, useEffect} from 'react';
import axiosWidgetInstance, {withApiKey, widgetEndpoints} from 'packages/common/utils/axiosWidget';
import {widgetLogger} from 'packages/common/utils/widgetLogger';

export const useExternalCompanyDetails = (companyId, apiKey) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState(null);
  const [companyDetails, setCompanyDetails] = useState(null);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      // Reset states
      setIsLoading(true);
      setIsError(false);
      setError(null);

      // Validate required parameters
      if (!companyId) {
        const missingError = new Error('Missing companyId');
        widgetLogger.warn('🏢 Company : ID entreprise manquant');
        setIsError(true);
        setError(missingError);
        setIsLoading(false);
        return;
      }

      if (!apiKey) {
        const missingError = new Error('Missing apiKey for company');
        widgetLogger.warn('🏢 Company : API key manquante');
        setIsError(true);
        setError(missingError);
        setIsLoading(false);
        return;
      }

      try {
        const response = await axiosWidgetInstance.get(
            widgetEndpoints.externalApi.company.details(companyId),
            withApiKey(apiKey),
        );

        setCompanyDetails(response.data?.data);
        setIsError(false);
      } catch (apiError) {
        // Les logs d'erreur sont gérés par l'intercepteur axios
        setError(apiError);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCompanyDetails();
  }, [companyId, apiKey]);

  return {
    companyDetails,
    isLoading,
    isError,
    error, // Expose the actual error for better error handling
  };
};
